import { FC } from 'react';
import { Tooltip, TooltipProps, Theme } from '@mui/material';

interface HtmlTooltipProps extends TooltipProps {
  offset?: [number, number];
}

const HtmlTooltip: FC<HtmlTooltipProps> = ({ offset = [0, 2], ...props }) => (
  <Tooltip
    {...props}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset,
          },
        },
      ],
    }}
    componentsProps={{
      tooltip: {
        sx: (theme: Theme) => ({
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          maxWidth: 320,
          fontSize: theme.typography.body2.fontSize,
          fontWeight: 600,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[6],
          p: 2,
          borderRadius: 2,
        }),
      },
    }}
  />
);

export default HtmlTooltip;
